@if (stepForm) {
  <form
    id="step-form"
    [formGroup]="stepForm">
    <div class="request-container-4 request-content4-scrollable aa-scrollable-y aa-scrollbar">
      <div class="request-content">
        <div class="form-header">
          {{ 'ITSM.CREATESERVICEREQUEST.DESCRIPTION' | translate }}
        </div>
        <div class="description">
          <aa-input-editor [name]="messageField"
            [formControlName]="messageField"
            label="{{ 'ITSM.CREATECASEPOPIN.DESCRIPTIONPLACEHOLDER' | translate }}"
            [required]="'required'">
          </aa-input-editor>
        </div>
        <div class="files">
          <aa-upload-files #filesToUpload
            [name]="fileToUploadField"
            [formControlName]="fileToUploadField"
            [prompt]="'ITSM.CREATECASEPOPIN.PROMPT' | translate"
            [height]="'10vh'"
            [width]="'10vw'"
            (filesChangeEmiter)="onFilesChange($event)"
            [autoClear]="false">
          </aa-upload-files>
        </div>
      </div>
    </div>
  </form>
}
